import { useLang } from "../../lib/i18n";

const MAP = {
  running: { dot: "bg-emerald-400", text: "text-emerald-300" },
  idle: { dot: "bg-amber-400", text: "text-amber-300" },
  maintenance: { dot: "bg-red-400", text: "text-red-300" },
  closed: { dot: "bg-slate-400", text: "text-slate-300" },
  setup: { dot: "bg-sky-400", text: "text-sky-300" },
};

export const StatusPill = ({ status = "running", testId = "plant-status-badge", extra }) => {
  const { t } = useLang();
  const key = MAP[status] ? status : "running";
  const s = MAP[key];
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-2.5 rounded-full border hairline bg-black/30 backdrop-blur-xl px-4 py-2 font-mono text-[11px] tracking-[0.18em] uppercase"
    >
      <span className={`h-2 w-2 rounded-full ${s.dot} ${status === "running" ? "pulse-dot" : ""}`} />
      <span className="text-[var(--sage)]">{t("status.plant")}</span>
      <span className={s.text}>{t(`status.${key}`)}</span>
      {extra && <span className="text-[var(--cream)]">· {extra}</span>}
    </span>
  );
};
